import { formatData } from "./utils";

export function getClientMessages(paygoID){
    return async function (dispatch){
        dispatch({
            type: "FETCH_CLIENT_MESSAGES_START",
            payload: ""
            
        })
        try{

            const response = await fetch(`/message/system/all?boxId=${paygoID}&timeFrom=&timeTo=`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            const infos = await response.json();

            console.log('MESSAGES IN REPORT POPUP INFO : ', infos);
            
            console.log({infos});
            if(infos.error){ 
                console.log("[ERROR] get client report list ", infos.error);
                dispatch({
                    type: "FETCH_CLIENT_MESSAGES_ERROR",
                    payload: infos.error
                    
                })
    
            } else {
    
                // Batch dispatches to prevent store.getState() calls during reducer execution
                dispatch({ type: "POPUP_CLIENT_MESSAGES_LIST", payload:infos.content })
                
                // Defer completion dispatch to next tick
                setTimeout(() => {
                    dispatch({ type: "FETCH_CLIENT_MESSAGES_FULFILLED", payload:"" })
                }, 0)
            }
        } catch(error){
            console.log("[ERROR] get client report list ", error);
            dispatch({
                type: "FETCH_CLIENT_MESSAGES_ERROR",
                payload: error
                
            })
        }

    }
}
export function getReports(){
    return async function (dispatch){
        dispatch({ type: "FETCH_REPORTS_START", payload: "" })
        try {
            const reports_id_list = await getReportIDs()

            const req = await fetch('/maintenance/reportList', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({
                    reportIdList: reports_id_list
                }),
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getReports res : ', res);
            // check err !
            let reports_info_list = res.infoList;
            const formated_reports_info_list = formatData(reports_info_list.reverse())
            
            // Batch dispatches to prevent store.getState() calls during reducer execution
            dispatch({
                type: "GET_REPORTS",
                payload: formated_reports_info_list
            })
            
            // Defer these dispatches to next tick to prevent reducer execution conflicts
            setTimeout(() => {
                dispatch({
                    type: "GET_ALL_CLIENTS_REPORTS",
                    payload: reports_info_list
                })
                dispatch({ type: "FETCH_REPORTS_FULFILLED", payload: "" })
            }, 0) 

        } catch (error) {
            console.log("[ERROR] get reports list : ", error);
            dispatch({ type: "FETCH_REPORTS_ERROR", payload: error })
        }
         
    }
}

async function getReportIDs(){
    let list = []
    const req = await fetch('/maintenance/boxReportList', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
        },
        body: JSON.stringify({
            paygoID: 'ALL',
            nbMax: 50,
            from: 0,
        }),
        credentials: 'same-origin',
    });
    const res = await req.json();
    console.log('getReportIDs : ', res); 
    // maintenanceList : ["1536668089-b0a6a600-8a19-","1536824792-5a5720c7-073a-","1536853964-1e7bd362-1f85-"]
    let reports_id_list = []
    if (res.maintenanceList) {
       reports_id_list = res.maintenanceList
    }
    return reports_id_list
    
}

export function updateReport(updated_report){
    console.log("FIRED ACTION UPDATE_REPORT", updated_report)
    return {
        type: "UPDATE_REPORT",
        payload: updated_report
        
    }
}